<template>
  <content-view>
    <div slot="header">
      <a-tabs defaultActiveKey="1" @change="callback" class="tradeRecord_tab">
        <a-tab-pane tab="出库记录" key="1"></a-tab-pane>
        <a-tab-pane tab="入库记录" key="2" forceRender></a-tab-pane>
      </a-tabs>
    </div>
    <div class="trade-record">
      <p class="trade-record_title">
        <a-icon type="info-circle" style="padding-right: 8px;color: #FFBF00;margin-top: 2px;"/>{{storagName}} - {{name}}
      </p>
      <a-table
        bordered
        :dataSource="outdataSource"
        :columns="columns"
        :pagination="outpagination"
        v-if="tradeRecord == 1"
        :rowKey="record => record.applyTime"
        @change="changePageOut"
      >
        <div slot="type" slot-scope="type">{{['','入库','出库','调拨'][type]}}</div>
        <div slot="state" slot-scope="state">{{['','','审批中','审批通过','审批不通过'][state]}}</div>
        <div slot="approvalTime" slot-scope="approvalTime">{{approvalTime ? approvalTime : "-"}}</div>
      </a-table>
      <a-table
        bordered
        :dataSource="indataSource"
        :columns="columns2"
        :pagination="inpagination"
        v-if="tradeRecord == 2"
        :rowKey="record => record.stockInTime"
        @change="changePageIn"
      >
        <div slot="type" slot-scope="type">{{['','入库','出库','调拨'][type]}}</div>
      </a-table>
    </div>
  </content-view>
</template>

<script type="text/javascript">
    export default {
        name: 'tradeRecord',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: '类型',
                    dataIndex: 'type',
                    scopedSlots: {
                        customRender: 'type'
                    }
                },
                {
                    title: '申请数量',
                    dataIndex: 'stockNum'
                },
                {
                    title: '申请原因',
                    width: '30%',
                    dataIndex: 'reason'
                },
                {
                    title: '申请人',
                    dataIndex: 'applyUser'
                },
                {
                    title: '申请时间',
                    dataIndex: 'applyTime',
                    scopedSlots: {
                        customRender: 'applyTime'
                    }
                },
                {
                    title: '审核结果',
                    dataIndex: 'state',
                    scopedSlots: {
                        customRender: 'state'
                    }
                },
                {
                    title: '审核人',
                    dataIndex: 'approvalUser'
                },
                {
                    title: '审核时间',
                    dataIndex: 'approvalTime',
                    scopedSlots: {
                        customRender: 'approvalTime'
                    }
                }
            ];
            const columns2 = [
                {
                    title: '类型',
                    dataIndex: 'type',
                    scopedSlots: {
                        customRender: 'type'
                    }
                },
                {
                    title: '入库数量',
                    dataIndex: 'num'
                },
                {
                    title: '入库时间',
                    width: '30%',
                    dataIndex: 'stockInTime'
                },
                {
                    title: '操作人',
                    dataIndex: 'operator'
                }
            ];
            return {
                columns,
                columns2,
                outdataSource: [],
                indataSource: [],
                inpagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                outpagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                tradeRecord: 1,
                id: this.$route.query.goodsId,
                storeageId: this.$route.query.storeageId,
                name: this.$route.query.name,
                storagName: this.$route.query.storagName,
            };
        },
        computed: {},
        methods: {
            callback(key) {
                this.tradeRecord = key;
            },
            //出库记录
            stockRemovalList(params) {
                var param = {
                    goodsId: this.id,
                    storeId: this.storeageId,
                    pageNum: this.outpagination.current,
                    pageSize: this.outpagination.pageSize
                };
                this.$api.storage.stockRemovalList({ body: param }).then(res => {
                    this.outdataSource = res.data;
                    this.outpagination.total = res.total;
                });
            },
            //入库记录
            stockInList(params) {
                var param = {
                    goodsId: this.id,
                    storeId: this.storeageId,
                    pageNum: this.outpagination.current,
                    pageSize: this.outpagination.pageSize
                };
                this.$api.storage.stockInList({ body: param }).then(res => {
                    this.indataSource = res.data;
                    this.inpagination.total = res.total;
                });
            },
            changePageIn(page) {
                this.inpagination.pageSize = page.pageSize;
                this.inpagination.current = page.current;
                this.stockInList();
            },
            changePageOut(page) {
                this.outpagination.pageSize = page.pageSize;
                this.outpagination.current = page.current;
                this.stockRemovalList();
            }
        },
        created() {},
        mounted() {
            this.stockRemovalList();
            this.stockInList();
        }
    };
</script>
<style lang="scss">
  .trade-record {
      background-color: #fff;
      padding: 24px 32px;
      border-radius: 2px;
      &_title {
          width: 100%;
          height: 40px;
          background: #fffbe6;
          border: 1px solid #ffe58f;
          border-radius: 4px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          padding-left: 16px;
          box-sizing: border-box;
      }
  }
  .tradeRecord_tab {
      .ant-tabs-ink-bar {
          background-color: #1890ff;
      }
      .ant-tabs-nav .ant-tabs-tab-active {
          color: #1890ff;
      }
  }
</style>